module.exports = __webpack_public_path__ + "img/131-S-Bronze SFTN Mat.jpg";